var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BodyNav',{attrs:{"items":_vm.optionsToShow},on:{"set-active-item":function($event){_vm.active = $event}}}),_c('div',{staticClass:"scrollable-body"},[(_vm.active)?_c('BodyMain',{attrs:{"active":_vm.active}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }